import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContaListarComponent } from './conta-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ContaListarComponent }
    ])],
    exports: [RouterModule]
})
export class ContaListarRoutingModule { }
